module.exports = __webpack_public_path__ + "static/media/spinner.452d8d71.svg";